import { render, staticRenderFns } from "./DetailsSectionList.vue?vue&type=template&id=7c169534&scoped=true&"
import script from "./DetailsSectionList.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionList.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSectionList.vue?vue&type=style&index=0&id=7c169534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c169534",
  null
  
)

export default component.exports